import React from "react";
import { IonItem, IonLabel, IonButton, IonIcon } from "@ionic/react";
import { createOutline, closeCircle, refreshCircle } from "ionicons/icons";
import { CustomerAddressType } from "../../generated/graphql";
import styles from "./CustomerAddress.module.scss";

interface CustomerAddressProps {
  address: CustomerAddressType;
  onPresentModal: () => void;
  deleteAddress: () => void;
  isDeleting: boolean;
}

const CustomerAddress: React.FC<CustomerAddressProps> = ({ address, onPresentModal, deleteAddress, isDeleting }) => {
  return (
    <IonItem>
      <IonLabel>
        <h2>
          {address.street}, {address.house}
        </h2>
        <p>{address.city}</p>
      </IonLabel>
      <IonButton onClick={onPresentModal} fill="clear" disabled={isDeleting}>
        <IonIcon icon={createOutline} />
      </IonButton>
      <IonButton onClick={deleteAddress} color={isDeleting ? "medium" : "danger"} fill="clear" disabled={isDeleting}>
        <IonIcon icon={isDeleting ? refreshCircle : closeCircle} className={isDeleting ? styles.spinIcon : ""} />
      </IonButton>
    </IonItem>
  );
};

export default CustomerAddress;
